
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { initSentry } from './services/sentry';
import './index.css';

// Initialize error monitoring as early as possible so bootstrap failures are
// captured. No-op unless VITE_SENTRY_DSN is configured.
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

createRoot(rootElement).render(
  <StrictMode>
    <Suspense fallback={
      <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-slate-900">
        <div className="animate-pulse text-slate-500 dark:text-slate-400">Loading...</div>
      </div>
    }>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>
);